module.exports = __webpack_public_path__ + "img/bitmap_agent@3x.30ac0f49.png";